import React from 'react'

function ContentBox({children,onClick}) {
  return (
    <div onClick={onClick} className=' bg-white shadow-lg transition ease-in-out duration-500 rounded-md p-3 cursor-pointer hover:transform scale-75 contentbox'>
        <div>
            {children}
        </div>
    </div>
  )
}

export default ContentBox